export const BALLOON_LAND: string = "balloon-sets-down";
export const IMPACT_DINOSAUR: string = "big-crash";
export const BOOMERANG_LOOP: string = "boomarang-loop";
export const CASINO_RINGING: string = "casino-ringring";
export const CHIME: string = "chime-balloon-reveal";
export const CROWD_START: string = "crowd-cheer-start";
export const CROWD_LOOP: string = "crowd-cheer";
export const FUUJIN_AIR: string = "fuujin-air-gust";
export const GAME_OVER: string = "game-over";
export const IMPACT_1: string = "impact-1";
export const IMPACT_2: string = "impact-2";
export const IMPACT_3: string = "impact-3";
export const IMPACT_BUILDING: string[] = [ IMPACT_1, IMPACT_2, IMPACT_3 ];
export const IMPACT_FUUJIN: string = "impact-air-gust";
export const IMPACT_BIRD: string = "impact-bird";
export const IMPACT_BOOMERANG: string = "impact-boomarang";
export const IMPACT_DYEBOMB: string = "impact-colourbomb";
export const IMPACT_LANTERN: string = "impact-paper-lantern";
export const IMPACT_SPUTNIK: string = "impact-satellite";
export const IMPACT_SCARAB: string = "impact-scarub";
export const IMPACT_PALETA: string = "impact-wet";
export const LEVEL_SUCCESS: string = "level-success";
export const DINOSAUR_STOMP: string = "lizardzilla-stomp";
export const MINIMAP_MOVE: string = "minimap-up";
export const PALETA_LAUNCH: string = "paleta-launch";
export const WINGFLAP: string = "parrot-wingflap";
export const POP_1: string = "pop-1";
export const POP_2: string = "pop-2";
export const POP: string[] = [ POP_1, POP_2 ];
export const POWERUP_HEALTH: string = "powerup-health-sfx";
export const POWERUP_SHIELD: string = "powerup-shield-sfx";
export const POWERUP_SHRINK_END: string = "powerup-shrink-end";
export const POWERUP_SHRINK: string = "powerup-shrink-sfx";
export const POWERUP_SPEED: string = "powerup-speedboost-sfx";
export const SPUTNIK_ENTER: string = "satellite-enters";
export const TICKET_EARNED: string = "ticket-earned";
export const UI_SELECT: string = "ui_select";
export const STEAM: string = "up-button-steam-2";
export const WOOSH_1: string = "woosh-quick-1";
export const WOOSH_2: string = "woosh-quick-2";
export const WOOSH: string[] = [ WOOSH_1, WOOSH_2 ];
